module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/427.72b6e719.png";